import { useTranslation } from 'react-i18next'
import { Tour, StepProps } from '@/components/tour'
import { Box, Stack } from '@/components/structure'
import { Label } from '@/components/text'
import { Button } from '@/components/button'
import useMediaQuery from '@/hooks/use-media-query'
import { colors, breakpoints } from '@/styles'
import { useHighlight } from '@/models/toaster/hooks'
import useDelayedMount from '@/hooks/use-delayed-mount'

const Content: React.FC<{ next: () => void; cancel: () => void }> = ({ next, cancel }) => {
  const { t } = useTranslation()
  return (
    <Stack gutter={16} maxWidth={216}>
      <Stack gutter={4}>
        <Label fontSize="14px">
          {t(
            'b.toaster.view.complete_contract.create_contract.add_tenant.tour.title',
            'Manually add a tenant'
          )}
        </Label>
        <Box color={colors.grey32}>
          <Label fontSize="12px" type="small">
            {t(
              'b.toaster.view.listing_dashboard.add_tenant.tour.description',
              `If your tenant applied outside of liv.rent, but you still want to use our digital contracts, don't sweat! You can manually add a tenant here.`
            )}
          </Label>
        </Box>
      </Stack>
      <Box width="100%" display="flex" justify="flex-end">
        <Box width={96}>
          <Button size="small" onClick={next}>
            {t('b.toaster.view.key_features.tour.button', 'Got it!')}
          </Button>
        </Box>
      </Box>
    </Stack>
  )
}

const steps: StepProps = [
  {
    selector: '#add-user-btn',
    content: props => <Content {...props} />
  }
]

type HighlightProps = {
  children?: React.ReactNode
  hide?: boolean
}

const Highlight: React.FC<HighlightProps> = ({ children, hide: propHide }) => {
  const { hide, next: onBeforeClose } = useHighlight(
    'complete_contract.create_contract',
    'add_tenant'
  )
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const delay = useDelayedMount(1000)
  return (
    <Tour
      hide={hide || !delay || propHide}
      steps={steps}
      position={displayMobile ? 'top' : 'right'}
      positionStrategy={displayMobile ? 'none' : 'lt'}
      showCloseButton={false}
      allowInteraction
      onBeforeClose={onBeforeClose}
    >
      {children}
    </Tour>
  )
}

export default Highlight
